<template>
  <div class="lab-staff">
    <StaffContents
    :profileImg="require('../../assets/img/lab/staff/05/profile.png')"
    :profileImgSp="require('../../assets/img/lab/staff/05/profile_sp.png')"
    profileAlt="05 HIKARU KOBAYASHI"
    answer01="2010年に鈴木章さんがノーベル化学賞を受賞されたのをきっかけに、有機化学の分野に興味を持ちました。学生時代の研究テーマは、有機金属触媒を用いた新規反応探索。具体的には、特異な位置選択性を持つヒドロホウ素化反応を研究しており、基質適用範囲拡大に向けた条件検討や、反応機構の解明をメインで行っていました。また、ヒドロホウ素化に限らず、様々な反応を有機金属触媒で進行させるべく、日夜研究に没頭する日々でした。"
    answer02="当初は消費者向けの商品を扱っている、いわゆるBtoCの企業を中心に就職活動をしていたのですが、だんだんと「化学でご飯を食べられるようになりたい」という思いが強くなり、研究に力を入れている企業を志望するようになりました。クレハは自社開発にプライドを持っているところがとても魅力的で、かつ選考でお会いした社員の方が非常にやさしく、他社と比較しても圧倒的に会社の雰囲気がいいと感じたことが決め手になりました。"
    answer03="入社してから現在まで、クレハマイクロスフェアーという自動車部品から粘着剤まで幅広い用途で使用される熱膨張性マイクロカプセルを担当しています。主なミッションは、ラボで開発した新規銘柄を、ラボでの品質を維持したまま、量産機へスケールアップすることです。ラボスケールから量産機のスケールにした際に生まれる様々な課題を解決するために、攪拌の動力や原料の仕込み方、後処理工程の条件等、とても細かく色々な部分をケアしなければなりません。その点に難しさを感じる反面、想像以上に面白い仕事と感じています。"
    answer04="直近の目標は、現在携わっているクレハマイクロスフェアーをより競争力のある製品に育て上げ、事業的な成長に貢献すること。将来的には、新製品でもスムーズな量産化が可能なシステムや技術を構築し、開発スピードの向上につながる技術を培っていければと考えています。クレハの製造力を牽引できる人間になりたいですね。製造の仕事には、研究室では味わえない面白さや魅力がたくさんあるので、とにかく今は色々なことに挑戦して経験を積みたいと考えています。"
    answer05="チャレンジに対して寛容なところ。もちろん、効果とリスクに関しては十分検討しなければなりませんが、その点さえクリアすれば自分がやりたいことや考えていることを実現しやすい風土です。また、いわき事業所は研究所と工場が近いことがとても魅力的。部署間のやり取りを密に行えますし、スピード感を持って仕事に取り組めます。周辺にはウィンタースポーツを楽しめる場所が多く、毎年冬になるのが待ち遠しくなりますよ（笑）。"
    answer06="夫婦で各地に出かけて観光をし、ご当地のおいしいグルメを食べたりして休みの日を満喫しています。冬場になると、会社の同期と近くにある大きなスキー場へスノーボードをしに行ったりもします。普段から体力作りのためにランニングをしていて、決められた時間内で徐々に走れる距離が長くなることが楽しく、また運動することで良いリフレッシュになっていますね。"
    :imageCut01="require('../../assets/img/lab/staff/05/image01.jpg')"
    :imageCut02="require('../../assets/img/lab/staff/05/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/lab/staff/05/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/lab/staff/05/image02_sp.jpg')"
    :schedule="require('../../assets/img/lab/staff/05/schedule.svg')"
    :scheduleSp="require('../../assets/img/lab/staff/05/schedule_sp.svg')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/lab/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents,
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
